{
  "nsw-grey": {
    "nsw-grey-50": "rgb(250, 250, 250)",
    "nsw-grey-100": "rgb(245, 245, 245)",
    "nsw-grey-150": "rgb(240, 240, 240)",
    "nsw-grey-200": "rgb(235, 235, 235)",
    "nsw-grey-250": "rgb(227, 229, 230)",
    "nsw-grey-300": "rgb(220, 223, 224)",
    "nsw-grey-350": "rgb(212, 217, 219)",
    "nsw-grey-400": "rgb(205, 211, 214)",
    "nsw-grey-450": "rgb(170, 176, 180)",
    "nsw-grey-500": "rgb(136, 143, 146)",
    "nsw-grey-550": "rgb(104, 111, 114)",
    "nsw-grey-600": "rgb(73, 80, 84)",
    "nsw-grey-650": "rgb(63, 69, 73)",
    "nsw-grey-700": "rgb(53, 59, 63)",
    "nsw-grey-750": "rgb(43, 49, 53)",
    "nsw-grey-800": "rgb(34, 39, 43)",
    "nsw-grey-850": "rgb(24, 28, 31)",
    "nsw-grey-900": "rgb(14, 17, 19)",
    "nsw-grey-950": "rgb(5, 7, 9)"
  },
  "nsw-green": {
    "nsw-green-50": "rgb(245, 255, 246)",
    "nsw-green-100": "rgb(236, 253, 238)",
    "nsw-green-150": "rgb(228, 252, 231)",
    "nsw-green-200": "rgb(219, 250, 223)",
    "nsw-green-250": "rgb(207, 247, 212)",
    "nsw-green-300": "rgb(194, 244, 201)",
    "nsw-green-350": "rgb(181, 240, 190)",
    "nsw-green-400": "rgb(168, 237, 179)",
    "nsw-green-450": "rgb(138, 220, 152)",
    "nsw-green-500": "rgb(106, 204, 125)",
    "nsw-green-550": "rgb(69, 187, 98)",
    "nsw-green-600": "rgb(0, 170, 69)",
    "nsw-green-650": "rgb(7, 142, 50)",
    "nsw-green-700": "rgb(7, 115, 32)",
    "nsw-green-750": "rgb(3, 89, 15)",
    "nsw-green-800": "rgb(0, 64, 0)",
    "nsw-green-850": "rgb(0, 48, 0)",
    "nsw-green-900": "rgb(0, 32, 0)",
    "nsw-green-950": "rgb(0, 17, 0)"
  },
  "nsw-teal": {
    "nsw-teal-50": "rgb(242, 251, 250)",
    "nsw-teal-100": "rgb(231, 247, 245)",
    "nsw-teal-150": "rgb(220, 242, 239)",
    "nsw-teal-200": "rgb(209, 238, 234)",
    "nsw-teal-250": "rgb(193, 234, 231)",
    "nsw-teal-300": "rgb(175, 229, 229)",
    "nsw-teal-350": "rgb(158, 224, 229)",
    "nsw-teal-400": "rgb(140, 219, 229)",
    "nsw-teal-450": "rgb(117, 196, 207)",
    "nsw-teal-500": "rgb(94, 172, 185)",
    "nsw-teal-550": "rgb(70, 150, 163)",
    "nsw-teal-600": "rgb(46, 128, 142)",
    "nsw-teal-650": "rgb(37, 111, 123)",
    "nsw-teal-700": "rgb(28, 95, 105)",
    "nsw-teal-750": "rgb(20, 78, 88)",
    "nsw-teal-800": "rgb(11, 63, 71)",
    "nsw-teal-850": "rgb(4, 47, 53)",
    "nsw-teal-900": "rgb(1, 31, 36)",
    "nsw-teal-950": "rgb(0, 17, 20)"
  },
  "nsw-blue": {
    "nsw-blue-50": "rgb(240, 251, 255)",
    "nsw-blue-100": "rgb(228, 246, 255)",
    "nsw-blue-150": "rgb(215, 242, 254)",
    "nsw-blue-200": "rgb(203, 237, 253)",
    "nsw-blue-250": "rgb(188, 234, 254)",
    "nsw-blue-300": "rgb(173, 231, 255)",
    "nsw-blue-350": "rgb(157, 227, 255)",
    "nsw-blue-400": "rgb(140, 224, 255)",
    "nsw-blue-450": "rgb(90, 201, 255)",
    "nsw-blue-500": "rgb(38, 174, 255)",
    "nsw-blue-550": "rgb(0, 143, 255)",
    "nsw-blue-600": "rgb(20, 108, 253)",
    "nsw-blue-650": "rgb(12, 90, 212)",
    "nsw-blue-700": "rgb(5, 72, 173)",
    "nsw-blue-750": "rgb(2, 54, 136)",
    "nsw-blue-800": "rgb(0, 38, 100)",
    "nsw-blue-850": "rgb(0, 26, 77)",
    "nsw-blue-900": "rgb(0, 16, 55)",
    "nsw-blue-950": "rgb(0, 6, 34)"
  },
  "nsw-purple": {
    "nsw-purple-50": "rgb(249, 247, 255)",
    "nsw-purple-100": "rgb(242, 240, 255)",
    "nsw-purple-150": "rgb(236, 232, 254)",
    "nsw-purple-200": "rgb(230, 225, 253)",
    "nsw-purple-250": "rgb(224, 217, 254)",
    "nsw-purple-300": "rgb(218, 208, 254)",
    "nsw-purple-350": "rgb(212, 200, 255)",
    "nsw-purple-400": "rgb(206, 191, 255)",
    "nsw-purple-450": "rgb(186, 166, 252)",
    "nsw-purple-500": "rgb(166, 141, 249)",
    "nsw-purple-550": "rgb(147, 114, 245)",
    "nsw-purple-600": "rgb(128, 85, 241)",
    "nsw-purple-650": "rgb(114, 67, 207)",
    "nsw-purple-700": "rgb(100, 50, 174)",
    "nsw-purple-750": "rgb(84, 33, 142)",
    "nsw-purple-800": "rgb(68, 17, 112)",
    "nsw-purple-850": "rgb(51, 8, 86)",
    "nsw-purple-900": "rgb(35, 2, 62)",
    "nsw-purple-950": "rgb(19, 0, 39)"
  },
  "nsw-fuchsia": {
    "nsw-fuchsia-50": "rgb(255, 246, 253)",
    "nsw-fuchsia-100": "rgb(255, 238, 249)",
    "nsw-fuchsia-150": "rgb(254, 230, 246)",
    "nsw-fuchsia-200": "rgb(253, 222, 242)",
    "nsw-fuchsia-250": "rgb(251, 212, 239)",
    "nsw-fuchsia-300": "rgb(249, 201, 235)",
    "nsw-fuchsia-350": "rgb(247, 191, 233)",
    "nsw-fuchsia-400": "rgb(244, 181, 230)",
    "nsw-fuchsia-450": "rgb(239, 150, 218)",
    "nsw-fuchsia-500": "rgb(233, 117, 204)",
    "nsw-fuchsia-550": "rgb(225, 80, 190)",
    "nsw-fuchsia-600": "rgb(217, 18, 174)",
    "nsw-fuchsia-650": "rgb(187, 12, 148)",
    "nsw-fuchsia-700": "rgb(157, 6, 123)",
    "nsw-fuchsia-750": "rgb(129, 2, 100)",
    "nsw-fuchsia-800": "rgb(101, 0, 77)",
    "nsw-fuchsia-850": "rgb(77, 0, 58)",
    "nsw-fuchsia-900": "rgb(55, 0, 40)",
    "nsw-fuchsia-950": "rgb(34, 0, 23)"
  },
  "nsw-red": {
    "nsw-red-50": "rgb(255, 248, 249)",
    "nsw-red-100": "rgb(255, 242, 244)",
    "nsw-red-150": "rgb(255, 236, 239)",
    "nsw-red-200": "rgb(255, 230, 234)",
    "nsw-red-250": "rgb(255, 219, 224)",
    "nsw-red-300": "rgb(255, 207, 214)",
    "nsw-red-350": "rgb(255, 196, 204)",
    "nsw-red-400": "rgb(255, 184, 193)",
    "nsw-red-450": "rgb(248, 151, 162)",
    "nsw-red-500": "rgb(239, 117, 129)",
    "nsw-red-550": "rgb(228, 79, 95)",
    "nsw-red-600": "rgb(215, 21, 58)",
    "nsw-red-650": "rgb(185, 14, 50)",
    "nsw-red-700": "rgb(155, 7, 42)",
    "nsw-red-750": "rgb(126, 3, 34)",
    "nsw-red-800": "rgb(99, 0, 25)",
    "nsw-red-850": "rgb(76, 0, 16)",
    "nsw-red-900": "rgb(54, 0, 8)",
    "nsw-red-950": "rgb(33, 0, 3)"
  },
  "nsw-orange": {
    "nsw-orange-50": "rgb(255, 250, 246)",
    "nsw-orange-100": "rgb(255, 246, 238)",
    "nsw-orange-150": "rgb(254, 241, 231)",
    "nsw-orange-200": "rgb(253, 237, 223)",
    "nsw-orange-250": "rgb(254, 229, 206)",
    "nsw-orange-300": "rgb(255, 221, 189)",
    "nsw-orange-350": "rgb(255, 214, 171)",
    "nsw-orange-400": "rgb(255, 206, 153)",
    "nsw-orange-450": "rgb(253, 182, 120)",
    "nsw-orange-500": "rgb(251, 157, 88)",
    "nsw-orange-550": "rgb(247, 129, 57)",
    "nsw-orange-600": "rgb(243, 99, 27)",
    "nsw-orange-650": "rgb(219, 81, 21)",
    "nsw-orange-700": "rgb(195, 63, 14)",
    "nsw-orange-750": "rgb(171, 46, 6)",
    "nsw-orange-800": "rgb(148, 27, 0)",
    "nsw-orange-850": "rgb(115, 15, 0)",
    "nsw-orange-900": "rgb(83, 4, 0)",
    "nsw-orange-950": "rgb(53, 0, 0)"
  },
  "nsw-yellow": {
    "nsw-yellow-50": "rgb(255, 252, 240)",
    "nsw-yellow-100": "rgb(255, 250, 229)",
    "nsw-yellow-150": "rgb(255, 247, 218)",
    "nsw-yellow-200": "rgb(255, 244, 207)",
    "nsw-yellow-250": "rgb(255, 241, 194)",
    "nsw-yellow-300": "rgb(254, 238, 181)",
    "nsw-yellow-350": "rgb(254, 234, 168)",
    "nsw-yellow-400": "rgb(253, 231, 154)",
    "nsw-yellow-450": "rgb(251, 218, 128)",
    "nsw-yellow-500": "rgb(250, 205, 99)",
    "nsw-yellow-550": "rgb(250, 190, 66)",
    "nsw-yellow-600": "rgb(250, 175, 5)",
    "nsw-yellow-650": "rgb(212, 148, 3)",
    "nsw-yellow-700": "rgb(175, 122, 1)",
    "nsw-yellow-750": "rgb(139, 96, 0)",
    "nsw-yellow-800": "rgb(105, 72, 0)",
    "nsw-yellow-850": "rgb(80, 53, 0)",
    "nsw-yellow-900": "rgb(57, 36, 0)",
    "nsw-yellow-950": "rgb(34, 19, 0)"
  },
  "nsw-brown": {
    "nsw-brown-50": "rgb(251, 248, 244)",
    "nsw-brown-100": "rgb(246, 241, 234)",
    "nsw-brown-150": "rgb(242, 234, 225)",
    "nsw-brown-200": "rgb(237, 227, 215)",
    "nsw-brown-250": "rgb(236, 222, 206)",
    "nsw-brown-300": "rgb(234, 218, 198)",
    "nsw-brown-350": "rgb(233, 213, 189)",
    "nsw-brown-400": "rgb(232, 208, 181)",
    "nsw-brown-450": "rgb(219, 191, 159)",
    "nsw-brown-500": "rgb(207, 174, 137)",
    "nsw-brown-550": "rgb(194, 157, 115)",
    "nsw-brown-600": "rgb(182, 141, 93)",
    "nsw-brown-650": "rgb(156, 118, 75)",
    "nsw-brown-700": "rgb(130, 96, 58)",
    "nsw-brown-750": "rgb(106, 75, 41)",
    "nsw-brown-800": "rgb(82, 55, 25)",
    "nsw-brown-850": "rgb(62, 40, 15)",
    "nsw-brown-900": "rgb(43, 26, 7)",
    "nsw-brown-950": "rgb(25, 13, 2)"
  },
  "nsw-aboriginal-grey": {
    "nsw-aboriginal-grey-50": "rgb(249, 248, 247)",
    "nsw-aboriginal-grey-100": "rgb(242, 241, 239)",
    "nsw-aboriginal-grey-150": "rgb(235, 234, 232)",
    "nsw-aboriginal-grey-200": "rgb(229, 227, 224)",
    "nsw-aboriginal-grey-250": "rgb(223, 220, 216)",
    "nsw-aboriginal-grey-300": "rgb(216, 212, 209)",
    "nsw-aboriginal-grey-350": "rgb(210, 205, 201)",
    "nsw-aboriginal-grey-400": "rgb(204, 198, 194)",
    "nsw-aboriginal-grey-450": "rgb(173, 168, 165)",
    "nsw-aboriginal-grey-500": "rgb(142, 139, 138)",
    "nsw-aboriginal-grey-550": "rgb(113, 112, 111)",
    "nsw-aboriginal-grey-600": "rgb(85, 85, 85)",
    "nsw-aboriginal-grey-650": "rgb(73, 73, 73)",
    "nsw-aboriginal-grey-700": "rgb(61, 61, 61)",
    "nsw-aboriginal-grey-750": "rgb(50, 50, 50)",
    "nsw-aboriginal-grey-800": "rgb(39, 39, 39)",
    "nsw-aboriginal-grey-850": "rgb(28, 28, 28)",
    "nsw-aboriginal-grey-900": "rgb(17, 17, 17)",
    "nsw-aboriginal-grey-950": "rgb(7, 7, 7)"
  },
  "nsw-aboriginal-red": {
    "nsw-aboriginal-red-50": "rgb(255, 245, 245)",
    "nsw-aboriginal-red-100": "rgb(255, 235, 235)",
    "nsw-aboriginal-red-150": "rgb(254, 226, 226)",
    "nsw-aboriginal-red-200": "rgb(253, 217, 217)",
    "nsw-aboriginal-red-250": "rgb(253, 208, 208)",
    "nsw-aboriginal-red-300": "rgb(252, 199, 198)",
    "nsw-aboriginal-red-350": "rgb(252, 189, 189)",
    "nsw-aboriginal-red-400": "rgb(251, 180, 179)",
    "nsw-aboriginal-red-450": "rgb(247, 150, 147)",
    "nsw-aboriginal-red-500": "rgb(242, 119, 113)",
    "nsw-aboriginal-red-550": "rgb(234, 85, 76)",
    "nsw-aboriginal-red-600": "rgb(225, 38, 28)",
    "nsw-aboriginal-red-650": "rgb(205, 31, 23)",
    "nsw-aboriginal-red-700": "rgb(186, 24, 17)",
    "nsw-aboriginal-red-750": "rgb(167, 17, 11)",
    "nsw-aboriginal-red-800": "rgb(149, 9, 6)",
    "nsw-aboriginal-red-850": "rgb(116, 0, 1)",
    "nsw-aboriginal-red-900": "rgb(84, 0, 0)",
    "nsw-aboriginal-red-950": "rgb(54, 0, 0)"
  },
  "nsw-aboriginal-orange": {
    "nsw-aboriginal-orange-50": "rgb(255, 244, 236)",
    "nsw-aboriginal-orange-100": "rgb(254, 233, 221)",
    "nsw-aboriginal-orange-150": "rgb(252, 223, 205)",
    "nsw-aboriginal-orange-200": "rgb(249, 212, 190)",
    "nsw-aboriginal-orange-250": "rgb(248, 202, 174)",
    "nsw-aboriginal-orange-300": "rgb(247, 191, 158)",
    "nsw-aboriginal-orange-350": "rgb(246, 181, 142)",
    "nsw-aboriginal-orange-400": "rgb(244, 170, 125)",
    "nsw-aboriginal-orange-450": "rgb(243, 154, 102)",
    "nsw-aboriginal-orange-500": "rgb(242, 137, 79)",
    "nsw-aboriginal-orange-550": "rgb(240, 119, 54)",
    "nsw-aboriginal-orange-600": "rgb(238, 99, 20)",
    "nsw-aboriginal-orange-650": "rgb(212, 83, 16)",
    "nsw-aboriginal-orange-700": "rgb(186, 68, 10)",
    "nsw-aboriginal-orange-750": "rgb(161, 53, 5)",
    "nsw-aboriginal-orange-800": "rgb(136, 38, 0)",
    "nsw-aboriginal-orange-850": "rgb(105, 25, 0)",
    "nsw-aboriginal-orange-900": "rgb(76, 13, 0)",
    "nsw-aboriginal-orange-950": "rgb(48, 3, 0)"
  },
  "nsw-aboriginal-brown": {
    "nsw-aboriginal-brown-50": "rgb(252, 241, 233)",
    "nsw-aboriginal-brown-100": "rgb(246, 227, 215)",
    "nsw-aboriginal-brown-150": "rgb(239, 213, 196)",
    "nsw-aboriginal-brown-200": "rgb(233, 200, 178)",
    "nsw-aboriginal-brown-250": "rgb(228, 186, 159)",
    "nsw-aboriginal-brown-300": "rgb(222, 173, 140)",
    "nsw-aboriginal-brown-350": "rgb(217, 159, 120)",
    "nsw-aboriginal-brown-400": "rgb(211, 145, 101)",
    "nsw-aboriginal-brown-450": "rgb(198, 129, 88)",
    "nsw-aboriginal-brown-500": "rgb(185, 114, 75)",
    "nsw-aboriginal-brown-550": "rgb(171, 98, 62)",
    "nsw-aboriginal-brown-600": "rgb(158, 83, 50)",
    "nsw-aboriginal-brown-650": "rgb(139, 70, 39)",
    "nsw-aboriginal-brown-700": "rgb(121, 57, 28)",
    "nsw-aboriginal-brown-750": "rgb(103, 45, 16)",
    "nsw-aboriginal-brown-800": "rgb(85, 33, 5)",
    "nsw-aboriginal-brown-850": "rgb(65, 22, 2)",
    "nsw-aboriginal-brown-900": "rgb(45, 12, 0)",
    "nsw-aboriginal-brown-950": "rgb(27, 4, 0)"
  },
  "nsw-aboriginal-yellow": {
    "nsw-aboriginal-yellow-50": "rgb(255, 252, 238)",
    "nsw-aboriginal-yellow-100": "rgb(255, 248, 224)",
    "nsw-aboriginal-yellow-150": "rgb(255, 245, 211)",
    "nsw-aboriginal-yellow-200": "rgb(255, 241, 197)",
    "nsw-aboriginal-yellow-250": "rgb(255, 238, 183)",
    "nsw-aboriginal-yellow-300": "rgb(255, 235, 169)",
    "nsw-aboriginal-yellow-350": "rgb(254, 231, 155)",
    "nsw-aboriginal-yellow-400": "rgb(254, 228, 140)",
    "nsw-aboriginal-yellow-450": "rgb(254, 214, 117)",
    "nsw-aboriginal-yellow-500": "rgb(254, 200, 93)",
    "nsw-aboriginal-yellow-550": "rgb(254, 185, 68)",
    "nsw-aboriginal-yellow-600": "rgb(254, 169, 39)",
    "nsw-aboriginal-yellow-650": "rgb(223, 150, 28)",
    "nsw-aboriginal-yellow-700": "rgb(193, 131, 18)",
    "nsw-aboriginal-yellow-750": "rgb(165, 112, 7)",
    "nsw-aboriginal-yellow-800": "rgb(137, 94, 0)",
    "nsw-aboriginal-yellow-850": "rgb(105, 71, 0)",
    "nsw-aboriginal-yellow-900": "rgb(76, 48, 0)",
    "nsw-aboriginal-yellow-950": "rgb(47, 28, 0)"
  },
  "nsw-aboriginal-green": {
    "nsw-aboriginal-green-50": "rgb(245, 249, 242)",
    "nsw-aboriginal-green-100": "rgb(236, 243, 231)",
    "nsw-aboriginal-green-150": "rgb(227, 236, 220)",
    "nsw-aboriginal-green-200": "rgb(218, 230, 209)",
    "nsw-aboriginal-green-250": "rgb(209, 224, 198)",
    "nsw-aboriginal-green-300": "rgb(199, 217, 186)",
    "nsw-aboriginal-green-350": "rgb(190, 211, 175)",
    "nsw-aboriginal-green-400": "rgb(181, 205, 164)",
    "nsw-aboriginal-green-450": "rgb(165, 194, 142)",
    "nsw-aboriginal-green-500": "rgb(149, 183, 119)",
    "nsw-aboriginal-green-550": "rgb(134, 172, 96)",
    "nsw-aboriginal-green-600": "rgb(120, 161, 70)",
    "nsw-aboriginal-green-650": "rgb(95, 143, 68)",
    "nsw-aboriginal-green-700": "rgb(73, 125, 64)",
    "nsw-aboriginal-green-750": "rgb(52, 106, 59)",
    "nsw-aboriginal-green-800": "rgb(33, 88, 52)",
    "nsw-aboriginal-green-850": "rgb(21, 66, 37)",
    "nsw-aboriginal-green-900": "rgb(10, 46, 23)",
    "nsw-aboriginal-green-950": "rgb(2, 27, 10)"
  },
  "nsw-aboriginal-blue": {
    "nsw-aboriginal-blue-50": "rgb(238, 248, 250)",
    "nsw-aboriginal-blue-100": "rgb(223, 241, 244)",
    "nsw-aboriginal-blue-150": "rgb(208, 233, 238)",
    "nsw-aboriginal-blue-200": "rgb(193, 226, 232)",
    "nsw-aboriginal-blue-250": "rgb(178, 219, 226)",
    "nsw-aboriginal-blue-300": "rgb(163, 212, 220)",
    "nsw-aboriginal-blue-350": "rgb(148, 204, 215)",
    "nsw-aboriginal-blue-400": "rgb(132, 197, 209)",
    "nsw-aboriginal-blue-450": "rgb(103, 174, 192)",
    "nsw-aboriginal-blue-500": "rgb(74, 150, 176)",
    "nsw-aboriginal-blue-550": "rgb(46, 127, 161)",
    "nsw-aboriginal-blue-600": "rgb(13, 103, 145)",
    "nsw-aboriginal-blue-650": "rgb(9, 93, 132)",
    "nsw-aboriginal-blue-700": "rgb(5, 83, 119)",
    "nsw-aboriginal-blue-750": "rgb(2, 73, 106)",
    "nsw-aboriginal-blue-800": "rgb(0, 64, 94)",
    "nsw-aboriginal-blue-850": "rgb(0, 47, 72)",
    "nsw-aboriginal-blue-900": "rgb(0, 32, 51)",
    "nsw-aboriginal-blue-950": "rgb(0, 17, 31)"
  },
  "nsw-aboriginal-purple": {
    "nsw-aboriginal-purple-50": "rgb(250, 241, 248)",
    "nsw-aboriginal-purple-100": "rgb(242, 229, 240)",
    "nsw-aboriginal-purple-150": "rgb(235, 216, 232)",
    "nsw-aboriginal-purple-200": "rgb(228, 204, 224)",
    "nsw-aboriginal-purple-250": "rgb(221, 191, 216)",
    "nsw-aboriginal-purple-300": "rgb(215, 179, 209)",
    "nsw-aboriginal-purple-350": "rgb(208, 166, 201)",
    "nsw-aboriginal-purple-400": "rgb(201, 154, 194)",
    "nsw-aboriginal-purple-450": "rgb(189, 139, 182)",
    "nsw-aboriginal-purple-500": "rgb(177, 124, 170)",
    "nsw-aboriginal-purple-550": "rgb(166, 109, 159)",
    "nsw-aboriginal-purple-600": "rgb(154, 94, 147)",
    "nsw-aboriginal-purple-650": "rgb(132, 79, 126)",
    "nsw-aboriginal-purple-700": "rgb(111, 65, 105)",
    "nsw-aboriginal-purple-750": "rgb(91, 51, 85)",
    "nsw-aboriginal-purple-800": "rgb(71, 38, 66)",
    "nsw-aboriginal-purple-850": "rgb(53, 26, 49)",
    "nsw-aboriginal-purple-900": "rgb(36, 16, 33)",
    "nsw-aboriginal-purple-950": "rgb(21, 6, 18)"
  },
  "success": {
    "success-50": "rgb(239, 249, 237)",
    "success-100": "rgb(224, 243, 222)",
    "success-150": "rgb(210, 236, 207)",
    "success-200": "rgb(196, 229, 192)",
    "success-250": "rgb(170, 214, 165)",
    "success-300": "rgb(143, 199, 138)",
    "success-350": "rgb(116, 183, 111)",
    "success-400": "rgb(88, 168, 84)",
    "success-450": "rgb(73, 161, 70)",
    "success-500": "rgb(57, 153, 54)",
    "success-550": "rgb(37, 146, 36)",
    "success-600": "rgb(0, 138, 7)",
    "success-650": "rgb(0, 114, 4)",
    "success-700": "rgb(0, 90, 2)",
    "success-750": "rgb(0, 68, 1)",
    "success-800": "rgb(0, 47, 0)",
    "success-850": "rgb(0, 34, 0)",
    "success-900": "rgb(0, 22, 0)",
    "success-950": "rgb(0, 11, 0)"
  },
  "warning": {
    "warning-50": "rgb(255, 243, 237)",
    "warning-100": "rgb(255, 232, 222)",
    "warning-150": "rgb(255, 221, 207)",
    "warning-200": "rgb(253, 210, 192)",
    "warning-250": "rgb(246, 189, 165)",
    "warning-300": "rgb(238, 168, 138)",
    "warning-350": "rgb(230, 147, 111)",
    "warning-400": "rgb(221, 125, 83)",
    "warning-450": "rgb(216, 114, 68)",
    "warning-500": "rgb(211, 103, 52)",
    "warning-550": "rgb(206, 92, 33)",
    "warning-600": "rgb(201, 80, 0)",
    "warning-650": "rgb(168, 63, 3)",
    "warning-700": "rgb(136, 47, 3)",
    "warning-750": "rgb(105, 32, 1)",
    "warning-800": "rgb(75, 18, 0)",
    "warning-850": "rgb(57, 10, 0)",
    "warning-900": "rgb(39, 4, 0)",
    "warning-950": "rgb(23, 1, 0)"
  },
  "danger": {
    "danger-50": "rgb(255, 240, 239)",
    "danger-100": "rgb(255, 226, 225)",
    "danger-150": "rgb(255, 212, 212)",
    "danger-200": "rgb(253, 198, 198)",
    "danger-250": "rgb(244, 172, 173)",
    "danger-300": "rgb(234, 146, 148)",
    "danger-350": "rgb(223, 120, 124)",
    "danger-400": "rgb(211, 93, 101)",
    "danger-450": "rgb(205, 78, 89)",
    "danger-500": "rgb(198, 63, 78)",
    "danger-550": "rgb(191, 44, 66)",
    "danger-600": "rgb(184, 18, 55)",
    "danger-650": "rgb(153, 11, 42)",
    "danger-700": "rgb(124, 6, 31)",
    "danger-750": "rgb(95, 2, 20)",
    "danger-800": "rgb(68, 0, 10)",
    "danger-850": "rgb(51, 0, 5)",
    "danger-900": "rgb(35, 0, 2)",
    "danger-950": "rgb(20, 0, 1)"
  },
  "info": {
    "info-50": "rgb(233, 238, 247)",
    "info-100": "rgb(212, 221, 235)",
    "info-150": "rgb(192, 204, 224)",
    "info-200": "rgb(172, 187, 213)",
    "info-250": "rgb(150, 169, 204)",
    "info-300": "rgb(128, 152, 194)",
    "info-350": "rgb(107, 134, 184)",
    "info-400": "rgb(87, 117, 174)",
    "info-450": "rgb(77, 108, 169)",
    "info-500": "rgb(66, 100, 164)",
    "info-550": "rgb(56, 91, 158)",
    "info-600": "rgb(46, 82, 153)",
    "info-650": "rgb(35, 66, 127)",
    "info-700": "rgb(25, 51, 102)",
    "info-750": "rgb(16, 37, 79)",
    "info-800": "rgb(7, 23, 56)",
    "info-850": "rgb(4, 15, 42)",
    "info-900": "rgb(2, 7, 28)",
    "info-950": "rgb(0, 3, 15)"
  },
  "white": "rgb(255, 255, 255)",
  "black": "rgb(0, 0, 0)"
}
